<template>
  <div
    id="app"
    :style="
      'background-color: ' +
      partner_color +
      '; height: 100vh; overflow: hidden;'
    "
  >
    <v-layout align-center justify-center row fill-height>
      <v-flex xs12 sm12 md8 class="hidden-sm-and-down" style="height: 100vh">
        <v-layout align-center justify-center row fill-height>
          <v-img
            :src="fundo"
            :style="`heigth: 100%; opacity: 0.5;`"
            height="100%"
          ></v-img>
          <!-- <div style="position: absolute; top: 0px;
             left: 100px; outline: 0px solid #444; padding: 20px">
             <span class="white--text pa-0 ma-0">Enercred</span>
             <h1 style="background: #fff" class="pb-3 pt-3 pr-4 pl-3 font-weight-bold font-italic">SUPER</h1>
          </div> -->
          <div
            style="
              position: absolute;
              top: 0px;
              right: 330px;
              outline: 0px solid #444;
              padding: 20px;
            "
          >
            <!-- <span class="black--text pa-0 ma-0">Enercred</span> -->
            <h1
              style="background: #282828; border: 1px; border-radius: 1px"
              class="pb-3 pt-3 pr-4 pl-3 font-weight-bold font-italic white--text"
            >
              SUPER
            </h1>
          </div>
          <!-- <div style="position: absolute; bottom: 10px; left: 10px;" class="white--text caption">© 2021 - Todos os direitos reservados. Equipe Enercred.</div> -->
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md4 style="background: #fff; height: 100vh">
        <div
          style="
            position: absolute;
            top: 0px;
            left: 10px;
            outline: 0px solid #444;
            padding: 0px 20px;
          "
          class="hidden-sm-and-up"
        >
          <!-- <span class="black--text pa-0 ma-0">Enercred</span> -->
          <h1
            style="background: #282828; border: 1px; border-radius: 1px"
            class="pb-3 pt-3 pr-4 pl-3 font-weight-bold font-italic white--text"
          >
            SUPER
          </h1>
        </div>
        <v-layout align-center justify-center column fill-height>
          <div v-if="partner_logo_url">
            <img :src="partner_logo_url" width="180px" />
          </div>
          <div v-else>
            <img
              src="/img/newJuntos_logo_color.png"
              width="250px"
              class="pb-3"
            />
          </div>
          <!-- <div class="display-1" style="padding-bottom: 40px; color: #808080">LOGIN</div> -->
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="*E-mail"
              prepend-inner-icon="email"
              name="email"
              type="email"
              @keyup.enter="validate"
              @input="clearErrorMsg"
              required
              outline
            ></v-text-field>
            <v-text-field
              v-model="password"
              name="password"
              :append-icon="show1 ? 'visibility' : 'visibility_off'"
              :rules="passwordRules"
              hint="Mínimo de 8 caracteres"
              label="*Senha"
              :type="show1 ? 'text' : 'password'"
              prepend-inner-icon="fingerprint"
              @click:append="show1 = !show1"
              @keyup.enter="validate"
              @input="clearErrorMsg"
              required
              outline
              class="pb-0"
            ></v-text-field>
            <div class="text-xs-right text-lg-right pt-0" style="width: 345px">
              <small>
                <router-link
                  class="pt-0"
                  style="color: grey; cursor: pointer"
                  :to="{ name: 'esquecisenha' }"
                  replace
                  >Esqueci minha senha</router-link
                >
              </small>
            </div>
            <div
              class="errorMsg caption pt-3 text-center"
              v-if="errorMsg !== ''"
            >
              <v-icon small color="error" class="mr-2">warning</v-icon>
              {{ errorMsg }}
            </div>
            <v-flex xs12 sm12 md12 text-sm-center>
              <v-btn
                :loading="loading"
                @click="validate"
                :disabled="!valid || loading"
                color="primary"
                large
                block
              >
                <span v-if="!loading">ENTRAR</span>
                <span v-else>AUTENTICANDO...</span>
              </v-btn>
            </v-flex>
          </v-form>
        </v-layout>
      </v-flex>
      <div
        style="position: absolute; bottom: 10px; right: 10px"
        class="grey--text caption"
      >
        © 2021 - Todos os direitos reservados. Equipe Enercred.
      </div>
    </v-layout>
    <!-- <a id="logo" href="https://alvarotrigo.com/fullPage/" alt="fullPage homepage">Enercred</a> -->
    <!-- <v-container fluid grid-list-md fill-height style="padding:3%;">
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 style="text-align: center">
            <div class="direita">
              <a
                href="http://enercred.com.br"
                target="_blank"
                alt="Enercred - Energia Limpa e Barata"
              >
                <img src="../assets/logo-enercred.png" style="padding: 5px" alt class="src" />
              </a>
              <img src="../assets/fundo.png" width="110%" class="hidden-sm-and-down" />
            </div>
          </v-flex>
          <v-flex d-flex xs12 sm12 md6 flex justify-center>
            <div class="form_cad">
              <div class="form_login">
                <div v-if="partner_logo_url">
                  <img :src="partner_logo_url" width="80%" />
                </div>
                <div class="display-1" style="padding-bottom: 40px; color: #808080">LOGIN</div>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="*E-mail"
                    prepend-icon="email"
                    name="email"
                    type="email"
                    @keyup.enter="validate"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    name="password"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :rules="passwordRules"
                    hint="Mínimo de 8 caracteres"
                    label="*Senha"
                    :type="show1 ? 'text' : 'password'"
                    prepend-icon="fingerprint"
                    @click:append="show1 = !show1"
                    @keyup.enter="validate"
                    required
                  ></v-text-field>
                  <div class="errorMsg" v-if="errorMsg !== ''">{{errorMsg}}</div>
                  <div class="text-xs-left text-lg-left">
                    <small>
                      <router-link :to="{ name: 'esquecisenha'}" replace>Esqueci minha senha</router-link>
                    </small>
                  </div>
                  <v-flex xs12 sm12 md12 text-sm-right style="text-align: right">
                    <v-btn
                      :loading="loading"
                      @click="validate"
                      :disabled="!valid || loading"
                      color="success"
                      flat
                      large
                    >ENTRAR</v-btn>
                  </v-flex>
                </v-form>
              </div>
            </div>
          </v-flex>
          <v-snackbar
            :color="color"
            :bottom="bottom"
            :top="top"
            :left="left"
            :right="right"
            v-model="snackbar"
            dark
          >
            <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
            <div>{{snackMessage}}</div>
            <v-icon size="16" @click="snackbar = true">mdi-close-circle</v-icon>
          </v-snackbar>
        </v-layout>
      </v-container> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import firestore from "../firebase/firestore";
import { getPartner } from "../services/firebase/partners";
// import { GET_USER } from "../graphql/users"

export default {
  name: "login",
  data: () => ({
    valid: false,
    show1: false,
    loader: null,
    loading: false,
    url_path: "",
    partner: "",
    partner_color: "#000",
    partner_logo_url: "",
    errorMsg: "",
    retryCount: 0,
    maxRetries: 2,
    email: "",
    emailRules: [
      (v) => !!v || "Por favor, informe o seu email",
      (v) => {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return (
          pattern.test(v) ||
          "Digite um email válido (exemplo: usuario@email.com)"
        );
      },
    ],
    password: "",
    passwordRules: [
      (v) => !!v || "Por favor, informe sua senha",
      (v) =>
        (v && v.length >= 8) || "A senha deve conter no mínimo 8 caracteres.",
    ],
    recipient_id: "",
    images: [
      "https://firebasestorage.googleapis.com/v0/b/enercred.appspot.com/o/web%2Flogin%2Fusina1.png?alt=media&token=d885f729-6d59-4fe7-bad4-17dc28b794d0",
      "https://firebasestorage.googleapis.com/v0/b/enercred.appspot.com/o/web%2Fsafiravmf_jul2020.jpeg?alt=media&token=3bf11694-6c12-43e3-8f98-498e44f06c5b",
      // 'https://firebasestorage.googleapis.com/v0/b/enercred.appspot.com/o/web%2Fmenu%2Fenercred-02.jpg?alt=media&token=b1cef068-4c99-4ec7-8c12-28ca4ee1070d',
      "https://firebasestorage.googleapis.com/v0/b/enercred.appspot.com/o/web%2Fmenu%2Fenercred-01.jpg?alt=media&token=65c3f63f-098e-41b9-9d09-d830f2c3e254",
      // 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-1.23832d31.jpg',
      // 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
      // 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-3.3a54f533.jpg',
      // 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-4.3b7e38ed.jpg'*/
    ],
  }),
  computed: {
    fundo() {
      return this.images[Math.floor(Math.random() * this.images.length)];
    },
  },
  watch: {
    images() {
      this.fundo = this.images[Math.floor(Math.random() * this.images.length)];
    },
  },
  mounted() {
    this.url_path = window.location.hostname;
    this.partner = this.url_path.split(".")[0] || "enercred";
    if (this.partner !== "enercred" && this.partner !== "localhost") {
      if (this.partner == "super") this.partner = "enercred";
      getPartner(this.partner)
        .then((partner) => {
          console.log("partner: ", partner);
          this.recipient_id = partner.data().recipient_id || "";
          this.partner_color = partner.data().color || "#1001F5";
          if (partner.data().logo_url)
            this.partner_logo_url = partner.data().logo_url || "enercred";
          if (partner.data().background_images)
            this.images = partner.data().background_images;
          console.log("this.partner_logo_url: ", this.partner_logo_url);
        })
        .catch((error) => console.error("Erro ao pegar o parceiro. ", error));
      // } else if(this.partner === "localhost") {
      //   getPartner('valedourado')
      //     .then(partner => {
      //       console.log('partner: ', partner)
      //       this.recipient_id = partner.data().recipient_id || ""
      //       this.partner_color = partner.data().color || "#1001F5"
      //       this.partner_logo_url = partner.data().logo_url || ""
      //       console.log('this.partner_logo_url: ', this.partner_logo_url)
      //       if(partner.data().background_images) this.images = partner.data().background_images
      //     })
      //     .catch(error => console.error("Erro ao pegar o parceiro. ", error))
    }
  },

  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.errorMsg = ""; // Limpa mensagens de erro anteriores
        await this.Login();
      }
    },
    // Método para traduzir códigos de erro do Firebase para mensagens em português
    getFirebaseErrorMessage(errorCode) {
      const errorMessages = {
        "auth/wrong-password":
          "Senha incorreta. Verifique sua senha e tente novamente.",
        "auth/user-not-found":
          "Email não encontrado. Verifique se você já possui uma conta ou cadastre-se.",
        "auth/invalid-email":
          "Email inválido. Verifique o formato do email digitado.",
        "auth/user-disabled":
          "Esta conta foi desabilitada. Entre em contato com o suporte.",
        "auth/too-many-requests":
          "Muitas tentativas de login. Tente novamente em alguns minutos.",
        "auth/network-request-failed":
          "Erro de conexão. Verifique sua internet e tente novamente.",
        "auth/timeout":
          "Tempo limite excedido. Verifique sua conexão e tente novamente.",
        "auth/invalid-credential":
          "Credenciais inválidas. Verifique seu email e senha.",
        "auth/account-exists-with-different-credential":
          "Já existe uma conta com este email usando outro método de login.",
        "auth/credential-already-in-use":
          "Esta credencial já está sendo usada por outra conta.",
        "auth/operation-not-allowed":
          "Operação não permitida. Entre em contato com o suporte.",
        "auth/weak-password":
          "A senha é muito fraca. Use pelo menos 8 caracteres.",
        "auth/email-already-in-use":
          "Este email já está sendo usado por outra conta.",
        "auth/requires-recent-login":
          "Por segurança, faça login novamente para continuar.",
        "auth/popup-closed-by-user": "Login cancelado pelo usuário.",
        "auth/cancelled-popup-request": "Operação cancelada. Tente novamente.",
        "auth/internal-error":
          "Erro interno do servidor. Tente novamente em alguns instantes.",
        default:
          "Erro inesperado durante o login. Tente novamente ou entre em contato com o suporte.",
      };

      return errorMessages[errorCode] || errorMessages["default"];
    },
    // Método para exibir erros de forma consistente
    handleAuthError(error, isRetry = false) {
      console.error("Erro de autenticação: ", error);
      this.loading = false;

      // Verifica se é um erro de rede e se ainda pode tentar novamente
      if (
        error.code === "auth/network-request-failed" &&
        this.retryCount < this.maxRetries &&
        !isRetry
      ) {
        this.retryCount++;
        this.errorMsg = `Tentando reconectar... (${this.retryCount}/${this.maxRetries})`;

        // Aguarda 2 segundos antes de tentar novamente
        setTimeout(() => {
          this.loading = true;
          this.Login(true); // Passa true para indicar que é um retry
        }, 2000);
        return;
      }

      // Reset o contador de retry para outros tipos de erro
      this.retryCount = 0;

      const errorMessage = this.getFirebaseErrorMessage(error.code);
      this.errorMsg = errorMessage;
    },
    ...mapActions(["login", "setInitialsConfig"]),
    Login: function (isRetry = false) {
      const formData = {
        email: this.email,
        password: this.password,
      };

      this.login(formData)
        .then((result) => {
          // Reset retry counter em caso de sucesso
          this.retryCount = 0;

          // Verifica se houve erro no resultado
          if (result && result.code) {
            this.handleAuthError(result, isRetry);
            return;
          }

          // Login bem-sucedido
          if (result && result.user) {
            this.handleSuccessfulLogin(result.user);
          } else {
            this.handleAuthError(
              {
                code: "auth/internal-error",
                message: "Resposta inesperada do servidor",
              },
              isRetry,
            );
          }
        })
        .catch((error) => {
          this.handleAuthError(error, isRetry);
        });
    },

    // Método para lidar com login bem-sucedido
    handleSuccessfulLogin(user) {
      firestore
        .collection("users")
        .doc(user.uid)
        .get()
        .then((res) => {
          if (!res.exists) {
            this.handleAuthError({
              code: "auth/user-not-found",
              message: "Dados do usuário não encontrados",
            });
            return;
          }

          // Processa dados do usuário
          const userData = res.data();
          if (this.recipient_id) {
            userData.recipient_id = this.recipient_id;
          }

          const user = {
            id: res.id,
            ...userData,
          };

          // Armazena dados do usuário
          this.$store.commit("storeUser", user);
          this.$store.dispatch("setInitialsConfig");
          this.loading = false;

          // Redireciona baseado no grupo do usuário
          this.redirectUserBasedOnGroup(user);
        })
        .catch((err) => {
          console.error("Erro ao buscar dados do usuário: ", err);
          this.loading = false;
          this.errorMsg =
            "Erro ao carregar dados do usuário. Tente fazer login novamente.";
        });
    },

    // Método para limpar mensagens de erro quando usuário digita
    clearErrorMsg() {
      if (this.errorMsg !== "") {
        this.errorMsg = "";
      }
    },

    // Método para redirecionar usuário baseado no grupo
    redirectUserBasedOnGroup(user) {
      const userGroups = user.group || [];

      if (userGroups.indexOf("admin") >= 0) {
        this.$router.replace("dashboard");
      } else if (userGroups.indexOf("partner") >= 0) {
        this.$router.replace("dashboard");
      } else if (
        userGroups.indexOf("sales") >= 0 ||
        userGroups.indexOf("sales_partner") >= 0 ||
        userGroups.indexOf("sales_partner_management") >= 0 ||
        userGroups.indexOf("sales_management") >= 0
      ) {
        this.$router.replace("vendas");
      } else if (
        userGroups.indexOf("customer_care") >= 0 ||
        userGroups.indexOf("collection") >= 0 ||
        userGroups.indexOf("external_collection") >= 0 ||
        userGroups.indexOf("eletron") >= 0
      ) {
        this.$router.replace("atendimento");
      } else if (userGroups.indexOf("financial") >= 0) {
        this.$router.replace("dashboard");
      } else if (userGroups.indexOf("marketing") >= 0) {
        this.$router.replace("leads");
      } else if (userGroups.indexOf("access_grantor") >= 0) {
        this.$router.replace("configuracao/usuarios");
      } else {
        this.$router.replace("membros/faturas/" + user.id);
      }
    },
  },
};
</script>

<style scoped>
html,
body {
  height: 100%;
}
.form_cad {
  height: 100%;
  vertical-align: -webkit-baseline-middle;
  vertical-align: middle;
  padding-left: 5%;
  padding-top: 20%;
  text-align: center;
  /* width: 80%; */
}
.form_login {
  /* width: 95%; */
  background-color: #fff;
  border-radius: 10px;
  /* padding: 10px; */
}
.direita {
  width: 90%;
  padding-left: 5%;
  padding-top: 10%;
  text-align: left;
}
.login {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
/*
    p {
        margin-top: 40px;
        font-size: 13px;
    }
    */
p a {
  text-decoration: underline;
  cursor: pointer;
}
.social-button {
  width: 75px;
  background: white;
  padding: 10px;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  outline: 0;
  border: 0;
}
.social-button:active {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.social-button img {
  width: 100%;
}
* {
  -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
  -moz-box-sizing: border-box; /* <=28 */
  box-sizing: border-box;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.errorMsg {
  color: #d32f2f;
  background-color: #ffebee;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
  max-width: 350px;
  padding: 12px 16px;
  margin: 8px auto 16px auto;
  text-align: center;
  font-size: 14px;
  line-height: 1.4;
  box-shadow: 0 2px 4px rgba(211, 47, 47, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
